<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            
           
              <div class="row  align-items-center form-header">
            <div class="col mt-4">
              <h4 class="ms-md-2 ms-lg-4 ms-md-4">Vendor Payments</h4>
            </div>
            
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end ">
              <llp-button
                classNames="btn-secondary new-btn d-none d-sm-block"
                @click="BackToServices()"
              >
                  Back To Vendor Payments
              </llp-button>
               <llp-button
                classNames="btn-secondary new-btn d-block d-sm-none add-btn"
                 @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>
            <div class="m-lg-4 m-md-4" v-if="!vendorRoleId">
              <div class="col-lg-3 col-md-6 col-sm-12">
                <llp-label
                  id="confirmPasswordLabel"
                  :aria-label="confirPassword"
                  >Vendor Names:</llp-label
                >
                <select
                  id="state"
                  class="form-control select-dropdown"
                  v-model="SelectedName"
                >
                  <option value="" disabled selected>
                    Please select vendor name
                  </option>
                  <option
                    v-for="vendorDetails in VendorData"
                    :key="vendorDetails.id"
                    :value="vendorDetails.id"
                  >
                    {{ vendorDetails.name }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="selectedVendor" class="m-lg-4 m-md-4">
              <div class="col-lg-5 col-md-8 col-sm-12 selected-data">
                <h5>Selected Vendor Details:</h5>
                <div class="card p-4">
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                      <strong>Name:</strong>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                      {{ selectedVendor.name }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                      <strong>Address:</strong>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                      {{ selectedVendor.address }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                      <strong>Pan Number:</strong>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                      {{ maskedPanNumber }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                      <strong>Mobile:</strong>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                      {{ selectedVendor.mobile }}
                    </div>
                  </div>

                  <div class="col-lg-7 col-md-7 col-sm-12 mt-3">
                    <llp-label id="amountLabel" :aria-label="amount"
                      >Amount:</llp-label
                    >
                    <llp-input
                      id="confirmpassword"
                      class="w-100"
                      autocomplete="off"
                      v-model="this.Amount"
                        :errors="validator.Amount.$errors"
                    ></llp-input>
                  </div>

                  <div class="col-lg-7 col-md-7 col-sm-6 mt-2">
                    <llp-button
                      :load-spinner="showaddUserSpinner"
                      classNames="btn-secondary new-btn"
                      type="button"
                      @click:button="fetchPaymentMethods()"
                    >
                      Proceed To Pay
                    </llp-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="vendorRoleId" class="m-lg-4 m-md-4">
              <div class="col-lg-5 col-md-8 col-sm-12">
                <h5>Selected Vendor Details:</h5>
                <div class="card p-4">
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                      <strong>Name:</strong>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                      {{ singleVendorData.name }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                      <strong>Address:</strong>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                      {{ singleVendorData.address }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                      <strong>Pan Number:</strong>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                      {{ maskedPanNumber }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                      <strong>Mobile:</strong>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                      {{ singleVendorData.mobile }}
                    </div>
                  </div>

                  <div class="col-lg-7 col-md-7 col-sm-12 mt-3">
                    <llp-label id="confirmPasswordLabel" :aria-label="amount"
                      >Amount:</llp-label
                    >
                    <llp-input
                      id="confirmpassword"
                      class="w-100"
                      autocomplete="off"
                      v-model="this.Amount"
                       :errors="validator.Amount.$errors"

                    ></llp-input>
                  </div>

                  <div class="col-lg-7 col-md-7 col-sm-6 mt-2">
                    <llp-button
                      :load-spinner="payloadSpinner"
                      classNames="btn-secondary new-btn"
                      type="button"
                      @click:button="fetchPaymentMethods()"
                    >
                      Proceed To Pay
                    </llp-button>
                  </div>
                </div>
              </div>
            </div>
            <Dialog
              v-model:visible="showPaymentDialog"
              header="Select Payment Method"
              modal
              :style="{ width: '90%', maxWidth: '45rem' }"
              :breakpoints="{ '960px': '75vw', '641px': '90vw' }"
              @hide="onHideDialog"
            >
              <div v-if="loading" class="loader-overlay">
                <div class="spinner"></div>
              </div>
              <span class="text-surface-500 dark:text-surface-400 block">
                Choose how you'd like to pay:
              </span>

              <div class="row mt-2">
                <div
                  class="col-6 mb-2"
                  v-for="method in paymentMethods"
                  :key="method.id"
                >
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="method.id"
                      :value="method.value"
                      v-model="selectedPaymentMethod"
                      name="paymentOption"
                      @change="handlePaymentMethodChange(method.value)"
                    />
                    <label class="form-check-label ms-2" :for="method.id">
                      {{ method.name }}
                    </label>
                  </div>
                </div>
              </div>
              
              <div v-if="selectedPaymentMethod === 'Credit Card/Debit Card'">
                <h5>Card details:</h5>
                <div class="row">
                  <div class="mb-2 col-lg-6 col-md-6 col-sm-12">
                    <llp-label>Card Number:</llp-label>
                    <llp-input
                      v-model="cardDetails.cardNumber"
                      class="w-100 mb-2"
                      placeholder="Enter card number"
                      :errors="validator.cardDetails.cardNumber.$errors"
                        @input="formatCardNumber"
                    ></llp-input>
                  </div>
                </div>

                <div class="row">
                  <div class="mb-2 col-lg-6 col-md-6 col-sm-6">
                    <llp-label>Name On Card</llp-label>
                    <llp-input
                      v-model="cardDetails.cardHolderName"
                      class="w-100 mb-2"
                      :errors="validator.cardDetails.cardHolderName.$errors"
                    />
                  </div>
                </div>
             
              </div>
               <div class="row" v-if="this.paymentCharges">
                <div class="col-6">
                  <p class="mb-1"><strong>Amount:</strong></p>
                  <p class="mb-3"><strong>Service Charge:</strong></p>
                </div>
                <div class="col-6">
                  <p class="mb-1">₹{{ paymentCharges.base_amount }}</p>
                  <p class="mb-3">₹{{ paymentCharges.charge_amount }}</p>
                </div>
              </div>
              <div class="flex justify-end gap-2">
                <button
                  class="btn btn-secondary"
                  :load-spinner="payloadSpinner"
                  @click="PayAmount"
                >
                  Pay Now
                  <span v-if="paymentCharges?.total_payable"
                    >(₹{{ paymentCharges.total_payable }})</span
                  >
                </button>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>
<script>
// import ErrorService from "../../../services/error.service";
import NetworkService from "@/services/network.service";
import Dialog from "primevue/dialog";
import _ from 'lodash';
import { useVuelidate } from "@vuelidate/core";
import { cardValidation } from "@/validations/cardValidation";
import {
  formatCardNumber as formatCardNumberUtil,
} from "@/validations/cardFormatters";
export default {
  components: { Dialog },
   setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      SelectedName: "",
      loading: false,
      vendorRoleId: this.$route.params.id,
      name: "",
      Amount: "",
      address: "",
      panNumber: "",
      paymentCharges: null,
      Mobile: "",
      serviceId: this.$route.params.serviceId,
      userId: localStorage.getItem("User_id"),
      role_id:localStorage.getItem('role_id'),
      selectedVendor: "",
      VendorData: [],
      maskedPanNumber: "",
      singleVendorData: [],
      showPaymentDialog: false,
      paymentMethods: [],
      selectedPaymentMethod: "",
      vendor_service_id: "",
        lastCardDigits: "",
        lastCardHolderName: "",
       cardDetails: {
        cardNumber: "",
        cardHolderName: "",
      },
       debouncedFetchCharges: null,

    };
  },
    created() {
    this.debouncedFetchCharges = _.debounce(this.fetchPaymentCharges, 4000);
  },
  watch: {
   Amount(newVal) {
    if (newVal !== "") {
      this.validator.Amount.$touch();      
      this.validator.Amount.$validate();   
    }
  },
    SelectedName(newVal) {
      if (newVal) {
        this.fetchSelectedVendorDetails(newVal);
      }
    },
     'cardDetails.cardNumber'() {
    this.tryFetchCharges();
  },
  'cardDetails.cardHolderName'() {
    this.tryFetchCharges();
  }
  },
  beforeUnmount() {
    if (this.debouncedFetchCharges) {
      this.debouncedFetchCharges.cancel();
    }
  },
  mounted() {
    const script = document.createElement("script");
    script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    script.async = true;
    document.head.appendChild(script);
    if (this.vendorRoleId) {
      this.fetchingSingleUserVendorDetails();
    } else if (this.serviceId) {
      this.fetchingVendorDetails();
    }
  },
validations() {
  return cardValidation;
},
  methods: {
    BackToServices() {
      this.$router.back();
    },
    async fetchingVendorDetails() {
      try {
        const vendorResponse = await NetworkService.get(
          `get-service-list-dropdown/${this.userId}/${this.serviceId}`
        );
        this.VendorData = vendorResponse.details;
      } catch (error) {
        this.$refs.toast.show("Unable to fetch the vendor details.", "error");
      }
    },
    async fetchSelectedVendorDetails(vendor) {
      this.vendor_service_id = vendor;
      try {
        const vendorResponse = await NetworkService.get(
          `get-service-list-for-pay/${vendor}/${this.userId}/${this.serviceId}`
        );
        this.selectedVendor = vendorResponse.details;
        if (this.selectedVendor.pan_number) {
          this.maskedPanNumber = this.selectedVendor.pan_number.replace(
            /.(?=.{4})/g,
            "*"
          );
        }
        this.Amount = vendorResponse.details.amount;
      } catch (error) {
        this.$refs.toast.show(
          "Unable to fetching the selected vendor details.",
          "error"
        );
      }
    },
    onHideDialog() {
    NetworkService.resetPaymentDialog(this);
  },
    async fetchingSingleUserVendorDetails() {
      try {
        const singleUserResponse = await NetworkService.get(
          `get-service-list-for-pay/${this.vendorRoleId}/${this.userId}/${this.serviceId}`
        );
        this.singleVendorData = singleUserResponse.details;
        if (this.singleVendorData.pan_number) {
          this.maskedPanNumber = this.singleVendorData.pan_number.replace(
            /.(?=.{4})/g,
            "*"
          );
        }
        this.Amount = this.singleVendorData.amount;
      } catch (error) {
        this.$refs.toast.show(
          "Unable to fetching the vendor details.",
          "error"
        );
      }
    },
tryFetchCharges() {
  if (this.selectedPaymentMethod !== 'Credit Card/Debit Card') return;
  const cleanNumber = this.cardDetails.cardNumber.replace(/\D/g, '');
  const holderName = this.cardDetails.cardHolderName?.trim();
  if (cleanNumber.length === 16 && holderName) {
    if (this.lastCardDigits !== cleanNumber || this.lastCardHolderName !== holderName) {
      this.lastCardDigits = cleanNumber;
      this.lastCardHolderName = holderName;
      this.debouncedFetchCharges('Credit Card/Debit Card', {
        card_number: cleanNumber,
      });
    }
  } else {
    this.paymentCharges = null;
  }
},
    async fetchPaymentMethods() {
      if (!this.selectedVendor && !this.Amount) {
    this.validator.Amount.$touch(); 
    return;
  }
  if (this.selectedVendor && !this.Amount) {
    this.validator.Amount.$touch(); 
    return;
  }
      this.showPaymentDialog = true;

      try {
        this.paymentMethods = await NetworkService.getPaymentMethods();
        if (this.paymentMethods.length === 0) {
          this.$refs.toast.show("No payment methods available", "warning");
        }
      } catch (error) {
        this.$refs.toast.show("Unable to fetch the payment methods", "error");
      }
    },
      formatCardNumber() {
          this.cardDetails.cardNumber = formatCardNumberUtil(this.cardDetails.cardNumber);
          this.validator.cardDetails.cardNumber.$touch();
        },
      
    handlePaymentMethodChange(methodValue) {
      this.selectedPaymentMethod = methodValue;
       this.paymentCharges = null;
       this.cardDetails.cardNumber = '';
    this.cardDetails.cardHolderName = '';
     if (this.validator?.cardDetails?.cardNumber) {
    this.validator.cardDetails.cardNumber.$reset();
  }
  if (this.validator?.cardDetails?.cardHolderName) {
    this.validator.cardDetails.cardHolderName.$reset();
  }
   if (methodValue !== 'Credit Card/Debit Card') {
    this.fetchPaymentCharges(methodValue);
  }
    },
    async fetchPaymentCharges(methodValue, extra = {}) {
      this.debouncedFetchCharges.cancel();

      if (!methodValue) return;

      this.loadingCharges = true;
       this.loading = true;
      try {
        const method = this.paymentMethods.find((m) => m.value === methodValue);
        if (!method) {
          throw new Error("Payment method not found");
        }
        const baseAmount = this.selectedSalaryPerson
          ? this.Amount
          : this.Amount;

          const payload =
          {
      user_id: this.userId,
      method_type: methodValue,
      base_amount: baseAmount,
       ...extra 
    }
        const response = await NetworkService.getPaymentCharges(method.id,this.role_id, payload);
    if (response.success === false) {
          this.$refs.toast.show(
            response.message || 'Unable to fetch payment charges',
            'error'
          );
          return;
        }

        this.paymentCharges = response;
         this.loading = false;
      } catch (err) {
        const msg =
          err?.response?.data?.message || err.message || 'Failed to fetch charges';
        this.$refs.toast.show(msg, 'error');
      } finally {
        this.loadingCharges = false;
         this.loading = false;

      }
    },
    async PayAmount() {
      if (!this.selectedPaymentMethod) {
        this.$refs.toast.show("Please select a payment method", "error");
        return;
      }

      if (this.selectedPaymentMethod === "Credit Card/Debit Card") {
        const isValid = await this.validator.$validate();
        if (!isValid) return;
      }

      this.payloadSpinner = true;

      try {
        const selectedMethod = this.paymentMethods.find(
          (method) => method.value === this.selectedPaymentMethod
        );

        const paymentDetails = this.selectedVendor
          ? {
              user_id: this.userId,
              base_amount: this.Amount,
              service_id: this.serviceId,
              // email: this.selectedVendor.email,
              mobile: this.selectedVendor.mobile,
              name: this.selectedVendor.name,
              payment_method_id: selectedMethod.id,
              service_user_id: this.vendor_service_id,
              account_number: this.selectedVendor.account_number,
              account_holder_name: this.selectedVendor.account_holder_name,
              bank_name: this.selectedVendor.bank_name,
              bank_branch: this.selectedVendor.bank_branch,
              ifsc_code: this.selectedVendor.ifsc_code,
              beneficiary_id: this.selectedVendor.beneficiary_id,
              charge_amount: this.paymentCharges.charge_amount,
              amount: this.paymentCharges.total_payable,
              method_type: this.selectedPaymentMethod,
              charge_percent:this.paymentCharges.charge_percent
            }
          : {
              user_id: this.userId,
              // email: this.singleVendorData.email,
              mobile: this.singleVendorData.mobile,
              name: this.singleVendorData.name,
              service_id: this.serviceId,
              payment_method_id: selectedMethod.id,
              service_user_id: this.vendorRoleId,
              base_amount: this.Amount,
              account_number: this.singleVendorData.account_number,
              account_holder_name: this.singleVendorData.account_holder_name,
              bank_name: this.singleVendorData.bank_name,
              bank_branch: this.singleVendorData.bank_branch,
              ifsc_code: this.singleVendorData.ifsc_code,
              beneficiary_id: this.singleVendorData.beneficiary_id,
              charge_amount: this.paymentCharges.charge_amount,
              amount: this.paymentCharges.total_payable,
              method_type: this.selectedPaymentMethod,
              charge_percent:this.paymentCharges.charge_percent
            };

        const result = await NetworkService.PaymentService.initiate(
          `get-payment-gateways-for-pay`,
          selectedMethod.id,
          paymentDetails
        );
  if (result.selected_method === 'auropay' && result?.order?.paymentLink) {
  window.location.href = result.order.paymentLink;
  return;
}
const paymentSessionId = result?.order?.data?.payment_session_id;
        if (paymentSessionId) {
          const cashfreeResult =
            await NetworkService.PaymentService.processCashfree(
              paymentSessionId
            );
          console.log("cashfreeResult", cashfreeResult);
          this.loading = true;
          setTimeout(async () => {
            await this.verifyPaymentStatus(result.order.data.order_id);
          }, 5000);
          // setTimeout(() => {
          //   this.loading = false;
          //   this.$router.push({
          //     name: "PaymentStatus",
          //     params: { order_id: result.order_id },
          //   });
          // }, 3000);
        } else {
          throw new Error("No payment session ID received from server");
        }
      } catch (error) {
        this.payloadSpinner = false;
        const errorInfo = NetworkService.PaymentService.handleError(error);
        this.$refs.toast.show(errorInfo.message, "error");
      }
    },
    //  async verifyPaymentStatus(orderId) {
    //   this.loading = false;
    //   try {
    //     const status = await NetworkService.PaymentService.verifyStatus(
    //       orderId
    //     );

    //     if (status === "SUCCESS") {
    //       this.$refs.toast.show("Payment successful", "success");
    //       this.loading = false;
    //       setTimeout(() => {
    //         this.$router.push({ name: "ThankYou" });
    //       }, 3000);
    //     } else if (status === "FAILED") {
    //       setTimeout(() => {
    //         this.loading = false;
    //         this.$refs.toast.show("Payment failed", "error");
    //       }, 3000);
    //     } else if (status === "PENDING") {
    //       setTimeout(() => {
    //         this.loading = false;
    //         this.$refs.toast.show("Payment is still pending", "info");
    //       }, 3000);
    //     } else {
    //       this.loading = false;
    //       this.$refs.toast.show("Payment Failed", "error");

    //     }
    //   } catch (error) {
    //     this.loading = false;
    //     const errorInfo = NetworkService.PaymentService.handleError(error);
    //     this.$refs.toast.show(errorInfo.message, "error");
    //   }
    // },
    async verifyPaymentStatus(orderId) {
  await NetworkService.PaymentService.verifyAndHandlePaymentStatus(orderId, this);
}
  },
};
</script>